
import { AppService } from "app/services/app.service";
import { AppFilter } from "app/models/app-filter.model";
import { Vaga } from "app/pages/full-pages/vaga/vaga.model";
import { Observable } from "rxjs";

export abstract class AbVaga extends AppService {
  abstract getVagas();
  abstract getAllVagas(filter: AppFilter): Observable<any>;
  abstract getAllVagasPage(filter: AppFilter): Observable<any>;
  abstract saveVaga(vaga: Vaga): Observable<any>;
  abstract saveVagas(vagas: Array<Vaga>): Observable<any>;
  abstract desativar(id: number);
  abstract getVagasByUnidade(filter: AppFilter): Observable<any>;
  abstract getAllVagasAtivas();
  abstract getAllVagasAtivasDeVisitantes();
}